import { ark } from '@ark-ui/react';
import { styled, type ComponentProps } from '@terra/ui-styled-system';

export type StyledMetricItemProps = ComponentProps<typeof StyledMetricItem>;
export const StyledMetricItem = styled(ark.button, {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1.5,
    px: 1.5,
    borderRadius: 'sm',
    position: 'relative',
    cursor: 'pointer',
    borderWidth: '1px',
    borderColor: 'transparent',
    background: 'transparent',
    color: 'fg.default',
    textStyle: 'sm',

    '& svg': {
      color: 'currentColor',
    },

    _disabled: {
      cursor: 'not-allowed',
      '& svg': {
        color: 'fg.disabled',
      },
    },
  },
});
